import React, { useState } from "react";
import { auth } from "../firebase"; // Import Firebase authentication instance
import { Container, Form, Button, Row, Col, Alert } from "react-bootstrap";
import { sendPasswordResetEmail } from "firebase/auth";
import RainbowBeard from "../images/rainbow-beard.jpg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  // Function to send a password reset email
  const handlePasswordReset = async (email) => {
    try {
      setLoading(true);
      setError("");
      setSuccess("");
      
      await sendPasswordResetEmail(auth, email);
      
      // Password reset email sent successfully
      setSuccess("Password reset email sent! Please check your inbox AND spam/junk folder. The email may be filtered by your email provider.");
      console.log("Password reset email sent successfully");
    } catch (error) {
      // Handle errors, e.g., if the email is not found
      console.error("Error sending password reset email: ", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     const userEmail = e.target.email.value;
  //     handlePasswordReset(userEmail);
  //   };

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePasswordReset(email); // Use the 'email' state variable
  };

  return (
    <Container className='mt-4'>
      <Row className='mt3 d-flex align-items-center'>
        <Col lg={6} className='whiteText mt-4 '>
          <h2>Reset Password</h2>
          
          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}
          
          {success && (
            <Alert variant="success" className="mb-3">
              {success}
            </Alert>
          )}
          
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId='formBasicEmail'>
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type='email'
                placeholder='Enter email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </Form.Group>
            <Row>
              <Col>
                <Button 
                  className='btn btn-primary mb-4' 
                  type="submit"
                  disabled={loading || !email}
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </Button>
              </Col>
              <Col></Col>
            </Row>
          </Form>
        </Col>
        <Col lg={6} className='text-center'>
          <img src={RainbowBeard} alt='Artist Showcase' className='img-fluid' />
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
